<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
        <template #header>
      <div class="list-page-panel is-header-minimal">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">菜单管理</h1>
            <p class="list-page-description">维护菜单树、权限标识、图标及层级关系。</p>
          </div>
          <div class="flex items-center justify-between gap-2">
            <!-- 操作按钮区域 -->
            <button
              class="btn-secondary inline-flex items-center gap-1"
              @click="toggleAllTrees"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
              展开/折叠
            </button>
            <button
              v-permission="'system:menu:add'"
              class="btn-primary inline-flex items-center gap-2"
              @click="openAddRootModal"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              新增菜单
            </button>
          </div>
        </div>
      </div>

    <!-- 菜单树表格 -->
    </template>
    <div class="data-table-shell">
      <div class="data-table-scroll">
      <table class="data-table">
        <thead class="data-table-head">
          <tr>
            <th class="data-table-th text-left">菜单名称</th>
            <th class="data-table-th text-left w-24">图标</th>
            <th class="data-table-th text-left w-20">类型</th>
            <th class="data-table-th text-left w-20">排序</th>
            <th class="data-table-th text-left">权限标识</th>
            <th class="data-table-th text-left w-24">状态</th>
            <th class="data-table-th text-left w-32">操作</th>
          </tr>
        </thead>
        <tbody class="data-table-body">
          <!-- 骨架屏加载状态 -->
          <template v-if="loading">
            <tr v-for="n in 3" :key="n" class="animate-pulse">
            <td class="data-table-td">
              <div class="flex items-center gap-1">
                <div class="w-4 h-4 bg-slate-200 rounded"></div>
                <div class="w-4 h-4 bg-slate-200 rounded"></div>
                <div class="h-4 w-24 bg-slate-200 rounded"></div>
              </div>
            </td>
            <td class="data-table-td is-center"><div class="w-5 h-5 bg-slate-200 rounded mx-auto"></div></td>
            <td class="data-table-td"><div class="h-5 w-14 bg-slate-200 rounded-full"></div></td>
            <td class="data-table-td"><div class="h-4 w-8 bg-slate-200 rounded"></div></td>
            <td class="data-table-td"><div class="h-4 w-32 bg-slate-200 rounded"></div></td>
            <td class="data-table-td"><div class="h-5 w-12 bg-slate-200 rounded-full"></div></td>
            <td class="data-table-td">
              <div class="flex items-center gap-1">
                <div class="h-8 w-8 bg-slate-200 rounded"></div>
                <div class="h-8 w-8 bg-slate-200 rounded"></div>
                <div class="h-8 w-8 bg-slate-200 rounded"></div>
              </div>
            </td>
          </tr>
          </template>
          <template v-for="menu in menuTree" :key="menu.id">
            <!-- 父节点 -->
            <tr class="tree-row parent data-table-row" :data-id="menu.id" :data-has-children="menu.children && menu.children.length > 0">
              <td class="data-table-td">
                <div class="flex items-center gap-1">
                  <button
                    v-if="menu.children && menu.children.length > 0"
                    class="tree-toggle w-4 h-4 text-slate-400 cursor-pointer"
                    :class="{ expanded: expandedIds.includes(menu.id) }"
                    @click="toggleTree(menu.id)"
                  >
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                    </svg>
                  </button>
                  <span v-else class="w-4 h-4"></span>
                  <svg class="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/>
                  </svg>
                  <span class="text-sm font-medium text-slate-900">{{ menu.name }}</span>
                </div>
              </td>
              <td class="data-table-td is-center">
                <component v-if="getIconComponent(menu.icon)" :is="getIconComponent(menu.icon)" class="w-5 h-5 text-slate-500 mx-auto" />
                <svg v-else class="w-5 h-5 text-slate-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
                </svg>
              </td>
              <td class="data-table-td">
                <span class="status-badge" :class="getTypeClass(menu.type)">
                  {{ getTypeText(menu.type) }}
                </span>
              </td>
              <td class="data-table-td text-sm text-slate-900">{{ menu.sort }}</td>
              <td class="data-table-td text-sm text-slate-500">{{ menu.perms || '-' }}</td>
              <td class="data-table-td">
                <span class="status-badge" :class="menu.status === STATUS_NORMAL ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                  <span class="w-1.5 h-1.5 rounded-full mr-1" :class="menu.status === STATUS_NORMAL ? 'bg-green-500' : 'bg-red-500'"></span>
                  {{ menu.status === STATUS_NORMAL ? '正常' : '停用' }}
                </span>
              </td>
              <td class="data-table-td">
                <div class="flex items-center gap-1">
                  <button v-permission="'system:menu:add'" class="table-action-button is-primary" title="新增" @click="openAddModal(menu)">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                    </svg>
                  </button>
                  <button v-permission="'system:menu:edit'" class="table-action-button is-primary" title="修改" @click="openEditModal(menu)">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button v-permission="'system:menu:remove'" class="table-action-button is-danger" title="删除" @click="deleteMenu(menu)">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            <!-- 一级子节点 -->
            <template v-if="menu.children && menu.children.length > 0">
              <template v-for="child in menu.children" :key="child.id">
                <tr
                  class="tree-row child data-table-row bg-slate-50/50"
                  :data-parent-id="menu.id"
                  :style="{ display: expandedIds.includes(menu.id) ? '' : 'none' }"
                >
                  <td class="data-table-td">
                    <div class="flex items-center gap-1 pl-8">
                      <button
                        v-if="child.children && child.children.length > 0"
                        class="tree-toggle w-4 h-4 text-slate-400 cursor-pointer"
                        :class="{ expanded: expandedIds.includes(child.id) }"
                        @click="toggleTree(child.id)"
                      >
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                        </svg>
                      </button>
                      <span v-else class="w-4 h-4"></span>
                      <svg v-if="child.type === TYPE_BUTTON" class="w-4 h-4 text-slate-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clip-rule="evenodd"/>
                      </svg>
                      <svg v-else class="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"/>
                      </svg>
                      <span class="text-sm text-slate-900">{{ child.name }}</span>
                    </div>
                  </td>
                  <td class="data-table-td is-center">
                    <span v-if="child.type === TYPE_BUTTON" class="text-xs text-slate-400">-</span>
                    <component
                      v-else-if="getIconComponent(child.icon)"
                      :is="getIconComponent(child.icon)"
                      class="w-5 h-5 text-slate-500 mx-auto"
                    />
                    <svg v-else class="w-5 h-5 text-slate-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
                    </svg>
                  </td>
                  <td class="data-table-td">
                    <span class="status-badge" :class="getTypeClass(child.type)">
                      {{ getTypeText(child.type) }}
                    </span>
                  </td>
                  <td class="data-table-td text-sm text-slate-900">{{ child.sort }}</td>
                  <td class="data-table-td text-sm text-slate-500">{{ child.perms || '-' }}</td>
                  <td class="data-table-td">
                    <span class="status-badge" :class="child.status === STATUS_NORMAL ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                      <span class="w-1.5 h-1.5 rounded-full mr-1" :class="child.status === STATUS_NORMAL ? 'bg-green-500' : 'bg-red-500'"></span>
                      {{ child.status === STATUS_NORMAL ? '正常' : '停用' }}
                    </span>
                  </td>
                  <td class="data-table-td">
                    <div class="flex items-center gap-1">
                      <button v-if="child.type !== TYPE_BUTTON" v-permission="'system:menu:add'" class="table-action-button is-primary" title="新增" @click="openAddModal(child)">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                        </svg>
                      </button>
                      <button v-permission="'system:menu:edit'" class="table-action-button is-primary" title="修改" @click="openEditModal(child)">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                        </svg>
                      </button>
                      <button v-permission="'system:menu:remove'" class="table-action-button is-danger" title="删除" @click="deleteMenu(child)">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                <!-- 二级子节点（第三层） -->
                <template v-if="expandedIds.includes(menu.id) && expandedIds.includes(child.id)">
                  <tr
                    v-for="grandChild in child.children"
                    :key="grandChild.id"
                    class="tree-row grand-child data-table-row bg-slate-100/50"
                    :data-parent-id="child.id"
                    style="display: table-row;"
                  >
                    <td class="data-table-td">
                      <div class="flex items-center gap-1 pl-16">
                        <span class="w-4 h-4"></span>
                        <svg v-if="grandChild.type === TYPE_BUTTON" class="w-4 h-4 text-slate-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clip-rule="evenodd"/>
                        </svg>
                        <svg v-else class="w-4 h-4 text-indigo-500" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"/>
                        </svg>
                        <span class="text-sm text-slate-900">{{ grandChild.name }}</span>
                      </div>
                    </td>
                    <td class="data-table-td is-center">
                      <span v-if="grandChild.type === TYPE_BUTTON" class="text-xs text-slate-400">-</span>
                      <component
                        v-else-if="getIconComponent(grandChild.icon)"
                        :is="getIconComponent(grandChild.icon)"
                        class="w-5 h-5 text-slate-500 mx-auto"
                      />
                      <svg v-else class="w-5 h-5 text-slate-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
                      </svg>
                    </td>
                    <td class="data-table-td">
                      <span class="status-badge" :class="getTypeClass(grandChild.type)">
                        {{ getTypeText(grandChild.type) }}
                      </span>
                    </td>
                    <td class="data-table-td text-sm text-slate-900">{{ grandChild.sort }}</td>
                    <td class="data-table-td text-sm text-slate-500">{{ grandChild.perms || '-' }}</td>
                    <td class="data-table-td">
                      <span class="status-badge" :class="grandChild.status === STATUS_NORMAL ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                        <span class="w-1.5 h-1.5 rounded-full mr-1" :class="grandChild.status === STATUS_NORMAL ? 'bg-green-500' : 'bg-red-500'"></span>
                        {{ grandChild.status === STATUS_NORMAL ? '正常' : '停用' }}
                      </span>
                    </td>
                    <td class="data-table-td">
                      <div class="flex items-center gap-1">
                        <button v-if="grandChild.type !== TYPE_BUTTON" v-permission="'system:menu:add'" class="table-action-button is-primary" title="新增" @click="openAddModal(grandChild)">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                          </svg>
                        </button>
                        <button v-permission="'system:menu:edit'" class="table-action-button is-primary" title="修改" @click="openEditModal(grandChild)">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                          </svg>
                        </button>
                        <button v-permission="'system:menu:remove'" class="table-action-button is-danger" title="删除" @click="deleteMenu(grandChild)">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>
        </tbody>
      </table>
      </div>
    </div>

    <!-- Modal Backdrop -->
    <div v-if="showModal" class="fixed inset-0 z-50" @click.self="closeModal">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);"></div>
    </div>

    <!-- Delete Confirm Modal -->
    <div v-if="showDeleteModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);" @click="closeDeleteModal"></div>
      <div class="modal-content relative bg-white rounded-xl shadow-xl w-full max-w-sm mx-4" style="animation: slideIn 0.2s ease-out;">
        <div class="p-6 text-center">
          <div class="w-12 h-12 mx-auto mb-4 text-red-500">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
          <h3 class="text-lg font-semibold text-slate-900 mb-2">确定要删除吗？</h3>
          <p class="text-sm text-slate-500 mb-6">删除后无法恢复，请确认是否删除。</p>
          <div class="flex items-center justify-center gap-3">
            <button @click="closeDeleteModal" class="btn-secondary">取消</button>
            <button @click="confirmDelete" class="btn-danger-secondary">确定删除</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add/Edit Modal -->
    <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);" @click="closeModal"></div>
      <div class="modal-content relative bg-white rounded-xl shadow-xl w-full max-w-lg mx-4" style="animation: slideIn 0.2s ease-out;">
        <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h3 class="text-lg font-semibold text-slate-900">{{ isEdit ? '修改菜单' : '新增菜单' }}</h3>
          <button @click="closeModal" class="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="p-6 space-y-4">
          <input type="hidden" :value="form.id">
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">菜单类型</label>
              <select v-model="form.type" class="form-select-native w-full">
                <option :value="TYPE_CATALOG">目录</option>
                <option :value="TYPE_MENU">菜单</option>
                <option :value="TYPE_BUTTON">按钮</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">显示状态</label>
              <select v-model="form.visible" class="form-select-native w-full">
                <option :value="1">显示</option>
                <option :value="0">隐藏</option>
              </select>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">上级菜单</label>
            <input type="text" :value="form.parentName || '顶级菜单无需选择'" readonly class="form-readonly w-full">
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">菜单名称 <span class="text-red-500">*</span></label>
            <input v-model="form.name" type="text" class="form-input w-full" placeholder="请输入菜单名称">
          </div>
          <!-- 路由地址：仅菜单显示 -->
          <div v-show="form.type === TYPE_MENU" class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">路由地址</label>
              <input v-model="form.path" type="text" class="form-input w-full" placeholder="如：system/user">
            </div>
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">排序号</label>
              <input v-model.number="form.sort" type="number" class="form-input w-full" placeholder="数字越大越靠后">
            </div>
          </div>
          <!-- 权限标识：菜单和按钮显示 -->
          <div v-show="form.type === TYPE_MENU || form.type === TYPE_BUTTON">
            <label class="block text-sm font-medium text-slate-700 mb-1">权限标识</label>
            <input v-model="form.perms" type="text" class="form-input w-full" placeholder="如：system:user:list">
          </div>
          <!-- 组件路径：仅菜单显示 -->
          <div v-show="form.type === TYPE_MENU">
            <label class="block text-sm font-medium text-slate-700 mb-1">组件路径</label>
            <input v-model="form.component" type="text" class="form-input w-full" placeholder="如：system/user/index">
          </div>
          <!-- 菜单图标：目录和菜单显示 -->
          <div v-show="form.type === TYPE_CATALOG || form.type === TYPE_MENU">
            <label class="block text-sm font-medium text-slate-700 mb-1">菜单图标</label>
            <div class="flex items-center gap-2">
              <input
                v-model="form.icon"
                type="text"
                class="form-input flex-1"
                placeholder="点击选择图标"
                readonly
                @click="showIconSelector = true"
              >
              <button
                type="button"
                class="px-3 py-2 bg-slate-100 border border-slate-300 rounded-lg text-sm hover:bg-slate-200 transition-colors"
                @click="showIconSelector = true"
              >
                选择图标
              </button>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl">
          <button @click="closeModal" class="btn-secondary">取消</button>
          <button @click="saveMenu" class="btn-primary">确定</button>
        </div>
      </div>
    </div>

    <!-- 图标选择弹窗 -->
    <div v-if="showIconSelector" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);" @click="showIconSelector = false"></div>
      <div class="modal-content relative bg-white rounded-xl shadow-xl w-full max-w-lg mx-4" style="animation: slideIn 0.2s ease-out;">
        <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h3 class="text-lg font-semibold text-slate-900">选择图标</h3>
          <button @click="showIconSelector = false" class="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="p-6">
          <IconSelector v-model="form.icon" />
        </div>
        <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl">
          <button @click="showIconSelector = false" class="btn-secondary">确定</button>
        </div>
      </div>
    </div>
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, onMounted, markRaw } from 'vue'
import { ElMessage } from 'element-plus'
import * as HeroIcons from '@heroicons/vue/24/outline'
import { getMenuTree, createMenu, updateMenu, deleteMenu as removeMenu } from '@/api/menu'
import ListPageShell from '@/components/ListPageShell.vue'
import IconSelector from './components/IconSelector.vue'

// Create icon component map (keep consistent with AppSidebar)
const iconComponents = {}
Object.keys(HeroIcons).forEach(name => {
  const iconName = name.replace(/Icon$/, '').replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^-/, '')
  iconComponents[iconName] = markRaw(HeroIcons[name])
})

// Get icon component
function getIconComponent(iconName) {
  if (!iconName) return null
  return iconComponents[iconName] || null
}

// 菜单数据
const menuTree = ref([])
const loading = ref(false)

// API类型常量 (0-目录, 1-菜单, 2-按钮)
const TYPE_CATALOG = 0
const TYPE_MENU = 1
const TYPE_BUTTON = 2

// API状态常量 (0-正常)
const STATUS_NORMAL = 0

// 加载菜单树
async function fetchMenuTree() {
  loading.value = true
  try {
    const data = await getMenuTree()
    menuTree.value = data || []
    // 默认展开所有有子节点的
    expandedIds.value = menuTree.value
      .filter(m => m.children && m.children.length > 0)
      .map(m => m.id)
  } catch (error) {
    ElMessage.error(error.message || '获取菜单列表失败')
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchMenuTree()
})

// 展开/折叠状态
const expandedIds = ref([])
const allExpanded = ref(false)

// 模态框状态
const showModal = ref(false)
const showDeleteModal = ref(false)
const showIconSelector = ref(false)
const isEdit = ref(false)
const pendingDelete = ref(null)

// 表单数据
const form = reactive({
  id: '',
  name: '',
  type: TYPE_CATALOG,
  status: STATUS_NORMAL,
  visible: 0,
  path: '',
  sort: 1,
  perms: '',
  component: '',
  icon: '',
  parentId: '',
  parentName: '',
  isCache: 0,
  isFrame: 0,
  redirect: ''
})

// 切换单个树节点
function toggleTree(menuId) {
  const index = expandedIds.value.indexOf(menuId)
  if (index > -1) {
    expandedIds.value.splice(index, 1)
  } else {
    expandedIds.value.push(menuId)
  }
}

// 展开/折叠所有
function toggleAllTrees() {
  allExpanded.value = !allExpanded.value
  if (allExpanded.value) {
    expandedIds.value = menuTree.value.filter(m => m.children && m.children.length > 0).map(m => m.id)
  } else {
    expandedIds.value = []
  }
}

// 获取类型样式
function getTypeClass(type) {
  const classes = {
    [TYPE_CATALOG]: 'bg-amber-100 text-amber-800',
    [TYPE_MENU]: 'bg-blue-100 text-blue-800',
    [TYPE_BUTTON]: 'bg-slate-100 text-slate-800'
  }
  return classes[type] || 'bg-slate-100 text-slate-800'
}

// 获取类型文本
function getTypeText(type) {
  const texts = {
    [TYPE_CATALOG]: '目录',
    [TYPE_MENU]: '菜单',
    [TYPE_BUTTON]: '按钮'
  }
  return texts[type] ?? type
}

// 打开新增顶层菜单模态框
function openAddRootModal() {
  isEdit.value = false
  form.id = ''
  form.parentId = 0
  form.parentName = ''
  form.name = ''
  form.type = TYPE_CATALOG
  form.status = STATUS_NORMAL
  form.visible = 0
  form.path = ''
  form.sort = 1
  form.perms = ''
  form.component = ''
  form.icon = ''
  form.isCache = 0
  form.isFrame = 0
  form.redirect = ''
  showModal.value = true
}

// 打开新增模态框
function openAddModal(menu) {
  isEdit.value = false
  form.id = ''
  form.parentId = menu.id
  form.parentName = menu.name
  form.name = ''
  form.type = TYPE_CATALOG
  form.status = STATUS_NORMAL
  form.visible = 0
  form.path = ''
  form.sort = 1
  form.perms = ''
  form.component = ''
  form.icon = ''
  form.isCache = 0
  form.isFrame = 0
  form.redirect = ''
  showModal.value = true
}

// 打开编辑模态框
function openEditModal(menu) {
  isEdit.value = true
  form.id = menu.id
  form.name = menu.name
  form.type = menu.type
  form.status = menu.status
  form.visible = menu.visible ?? 1
  form.path = menu.path || ''
  form.sort = menu.sort || 1
  form.perms = menu.perms || ''
  form.component = menu.component || ''
  form.icon = menu.icon || ''
  form.parentId = menu.parentId || ''
  form.parentName = menu.parentId === 0 ? '' : getParentName(menu.id)
  form.isCache = menu.isCache ?? 0
  form.isFrame = menu.isFrame ?? 0
  form.redirect = menu.redirect || ''
  showModal.value = true
}

// 获取父级菜单名称
function getParentName(menuId) {
  for (const menu of menuTree.value) {
    if (menu.children) {
      const child = menu.children.find(c => c.id === menuId)
      if (child) return menu.name
    }
  }
  return ''
}

// 关闭模态框
function closeModal() {
  showModal.value = false
  showIconSelector.value = false
}

// 保存菜单
async function saveMenu() {
  if (!form.name.trim()) {
    ElMessage.warning('请输入菜单名称')
    return
  }

  if (form.type === TYPE_MENU && !form.path.trim()) {
    ElMessage.warning('请输入路由地址')
    return
  }

  if ((form.type === TYPE_MENU || form.type === TYPE_BUTTON) && !form.perms.trim()) {
    ElMessage.warning('请输入权限标识')
    return
  }

  const submitData = {
    name: form.name,
    type: form.type,
    status: form.status,
    parentId: form.parentId || 0,
    path: form.path || '',
    component: form.component || '',
    redirect: form.redirect || '',
    perms: form.perms || '',
    icon: form.icon || '',
    sort: form.sort ?? 1,
    visible: form.visible === 0 ? 0 : 1,
    isCache: form.isCache ?? 0,
    isFrame: form.isFrame ?? 0
  }

  try {
    if (isEdit.value) {
      // 编辑
      await updateMenu(form.id, submitData)
      ElMessage.success('修改成功')
    } else {
      // 新增
      await createMenu(submitData)
      ElMessage.success('新增成功')
    }
    await fetchMenuTree()
  } catch (error) {
    ElMessage.error(error.message || '操作失败')
    return
  }

  closeModal()
}

// 删除菜单
function deleteMenu(menu) {
  pendingDelete.value = menu
  showDeleteModal.value = true
}

// 确认删除
async function confirmDelete() {
  if (!pendingDelete.value) return

  try {
    await removeMenu(pendingDelete.value.id)
    ElMessage.success('删除成功')
    await fetchMenuTree()
  } catch (error) {
    ElMessage.error(error.message || '删除失败')
  } finally {
    pendingDelete.value = null
    closeDeleteModal()
  }
}

// 关闭删除确认弹窗
function closeDeleteModal() {
  showDeleteModal.value = false
  pendingDelete.value = null
}
</script>

<style scoped>
.tree-toggle {
  transition: transform 0.2s;
}
.tree-toggle.expanded {
  transform: rotate(90deg);
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
